import { Check, Close } from '@mui/icons-material';
import { Dialog, DialogContent } from '@mui/material';
import PropTypes from 'prop-types';

import { navigateToMarketingSite } from '../../../utils/navigator';
import Button from '../../atoms/button';
import SubscriptionDialogGradientBg from '../../../images/subscription-gradient-bg.svg';
import SubscriptionDialogImage1 from '../../../images/subscription-dialog.svg';
import SubscriptionDialogImage2 from '../../../images/subscription-dialog-2.svg';

const PRO_FEATURES = [
  'Unlimited users',
  'Auto-generated timelines',
  'Unlimited projects',
  'Tag-teaming',
  'Exporting and sharing',
  'Resource-first planning',
];

const UpgradeToProModal = (props) => {
  // init
  const { isDialogOpen, setIsDialogOpen } = props;

  const handleClose = () => {
    setIsDialogOpen(false);
  };

  const handleUpgradeToProClick = () => {
    handleClose();
    navigateToMarketingSite('#contactus', true);
  };

  return (
    <Dialog onClose={handleClose} open={isDialogOpen} className="upgrade-to-pro-modal">
      <DialogContent className="upgrade-modal-content">
        <Button onClick={handleClose} style={{ backgroundColor: '#E5F2FE' }} primary text disableRipple className="dialog-close"><Close /></Button>
        <img src={SubscriptionDialogImage1} alt="Subscription Dialog" className="subscription-dialog-image-1" />
        <img src={SubscriptionDialogImage2} alt="Subscription Dialog" className="subscription-dialog-image-2" />
        <img src={SubscriptionDialogGradientBg} alt="Subscription Dialog" className="subscription-dialog-gradient-bg" />
        <div className="upgrade-details">
          <h3 className="upgrade-title">Upgrade for unlimited access to Simple Plan!</h3>
          <p className="upgrade-subtitle">Premium accounts have full access to all features without limitations</p>
          <div className="pro-features">
            {PRO_FEATURES.map((feature) => <span className="feature" key={feature}><Check fontSize="small" />{feature}</span>)}
          </div>
          <Button onClick={handleUpgradeToProClick} primary className="upgrade-button">Upgrade to Pro</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

UpgradeToProModal.propTypes = {
  isDialogOpen: PropTypes.bool.isRequired,
  setIsDialogOpen: PropTypes.func.isRequired,
};

export default UpgradeToProModal;
